import emptySplitApi from "../utils/rtk";
import { CommonBody, VisaType } from "../types/General";
import { END_POINTS } from "../constants/urls";

type CommonResponseType = {
  status: number;
  message: string;
};
type GetVisaTypeResponse = {
  length: number;
  start: number;
  response_object: VisaType[];
  total_records: number;
};

export const visaTypes = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    visaTypesList: builder.mutation<
      CommonResponseType & { data: GetVisaTypeResponse },
      CommonBody
    >({
      query: (body) => ({
        url: END_POINTS.getAllVisaTypes,
        method: "POST",
        body,
      }),
    }),

    visaTypeDetails: builder.query<
      CommonResponseType & { data: VisaType },
      { id: number }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.visaTypeById}${id}/`,
        method: "GET",
      }),
    }),
    updateVisaType: builder.mutation<
      CommonResponseType & { data: VisaType },
      { body: CommonBody; id: number }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateVisaType}${id}/`,
        method: "PUT",
        body,
      }),
    }),
  }),
});

export const {
  useVisaTypesListMutation,
  useLazyVisaTypeDetailsQuery,
  useUpdateVisaTypeMutation,
} = visaTypes;
